import React, { useEffect, useState } from 'react'
import { firestore } from '../../../../firebase'

import { MDBModal, MDBModalBody, MDBModalHeader } from 'mdbreact';

function ImagePickerReturnUrl({show, setShow, imageUrl, setImageUrl}) {

    const [images, setImages] = useState([])

    function toggleModal() {
        if (show) {
            setShow(false)
        } else {
            setShow(true)
        }
    }

    useEffect(() => {

        if (show) {
            try {
                const imagesRef = firestore.collection("images");
                imagesRef.orderBy("createdAt", "desc").onSnapshot(({docs}) => {
                    const images = docs.map(doc => {
                        return {id: doc.id, ...doc.data()}
                    })
                    setImages(images)
                })
            } catch (error) {
                
            }
        }

    }, [show])

    return (
        <MDBModal size="fluid" isOpen={show} toggle={toggleModal}>
            <MDBModalHeader toggle={toggleModal}>Velg bilde</MDBModalHeader>
            <MDBModalBody>

                <div className="row">
                    {images?.map((image, index) => {
                        return (
                            <div className="col-4 col-md-3 col-xl-2 my-3" key={index} >
                                <img src={image.imageUrl} onClick={() => setImageUrl(image.imageUrl)} alt="" className="img-fluid player-image" style={imageUrl === image.imageUrl ? {border: "5px solid royalblue"} : {border: "none"}} />
                            </div>
                        )
                    })}
                </div>

            </MDBModalBody>
        </MDBModal>
    )
}
export default ImagePickerReturnUrl